import React from 'react';
import { Box, Typography } from '@mui/material';

/** Levels in a Space Invader run (server: space_invader_gm.MAX_LEVEL). */
export const SI_MAX_LEVEL = 5;

/** HUD label, e.g. "Level 3/5". */
export function formatSiLevel(level, maxLevel = SI_MAX_LEVEL) {
    const max = Number.isFinite(maxLevel) && maxLevel > 0 ? maxLevel : SI_MAX_LEVEL;
    const lv = Number.isFinite(level) && level > 0 ? Math.min(level, max) : 1;
    return `Level ${lv}/${max}`;
}

/**
 * Overlay shown over the playfield during the ~1.5 s level transition
 * (server sends transition > 0 ticks) and on a won run.
 */
const SiLevelBanner = ({ level, maxLevel = SI_MAX_LEVEL, transition = 0, won = false }) => {
    if (!won && !(transition > 0)) return null;
    return (
        <Box
            data-testid="si-level-banner"
            role="status"
            sx={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none',
                background: 'rgba(0,0,0,0.45)',
            }}
        >
            <Typography sx={{ color: '#fff', fontWeight: 800, fontSize: { xs: '1.6rem', md: '2.4rem' }, letterSpacing: 2 }}>
                {won ? 'Victory!' : formatSiLevel(level, maxLevel)}
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.9rem' }}>
                {won ? `All ${maxLevel} levels cleared` : 'Get ready…'}
            </Typography>
        </Box>
    );
};

export default SiLevelBanner;
